export default "__VITE_ASSET__BQs_wz$b__"